import { render, staticRenderFns } from "./cardTemplateVip08.vue?vue&type=template&id=cfb86d2c&scoped=true&"
import script from "./cardTemplateVip08.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip08.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip08.vue?vue&type=style&index=0&id=cfb86d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb86d2c",
  null
  
)

export default component.exports